/*
 * Copyright (c) 2023-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

export class EventStatusHelpers {
  static getEventStatusInfo = (status?: string) => {
    return status ? EVENT_STATUS_TAG[status as EventStatus] : { text: 'Unidentified event status' }
  }
}

enum EventStatus {
  UPCOMING = 'UPCOMING',
  ONGOING = 'ONGOING',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED'
}

// Note: EVENT_STATUS_TAG here has a different type with the EventStatusHelpers in CPA
const EVENT_STATUS_TAG: Record<EventStatus, string> = {
  [EventStatus.UPCOMING]: 'Upcoming',
  [EventStatus.ONGOING]: 'Ongoing',
  [EventStatus.CANCELLED]: 'Cancelled',
  [EventStatus.COMPLETED]: 'Completed'
}
